import React from 'react';
import { Translate } from '@above-the-treeline/localization';
import './notAMemberOfAnyCommunityMessage.less';

function NotAMemberOfAnyCommunityMessage() {
	return (
		<p className="not-a-member-of-any-community-message">
			<Translate id="not_member_of_any_communities" />
		</p>
	);
}

export default NotAMemberOfAnyCommunityMessage;
